var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup1000003347(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 260,
    viewBox: "0 0 106 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14.1245,
    height: 14.1245,
    transform: "matrix(0.696258 0.717792 -0.696258 0.717792 9.83435 0)",
    fill: "#D41D24"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 14.1245,
    height: 14.1245,
    transform: "matrix(0.696258 0.717792 -0.696258 0.717792 9.83435 66.9104)",
    fill: "#D41D24"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 14.1245,
    height: 14.1245,
    transform: "matrix(0.696258 0.717792 -0.696258 0.717792 9.83435 131.431)",
    fill: "#D41D24"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 14.1245,
    height: 14.1245,
    transform: "matrix(0.696258 0.717792 -0.696258 0.717792 9.83435 198.342)",
    fill: "#D41D24"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 14.1245,
    height: 14.1245,
    transform: "matrix(0.696258 0.717792 -0.696258 0.717792 95.9969 0)",
    fill: "#D41D24"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 14.1245,
    height: 14.1245,
    transform: "matrix(0.696258 0.717792 -0.696258 0.717792 95.9969 66.9104)",
    fill: "#D41D24"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 14.1245,
    height: 14.1245,
    transform: "matrix(0.696258 0.717792 -0.696258 0.717792 95.9969 131.431)",
    fill: "#D41D24"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 14.1245,
    height: 14.1245,
    transform: "matrix(0.696258 0.717792 -0.696258 0.717792 95.9969 198.342)",
    fill: "#D41D24"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 14.1245,
    height: 14.1245,
    transform: "matrix(0.696258 0.717792 -0.696258 0.717792 51.9554 40.6241)",
    fill: "#D41D24"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    width: 14.1245,
    height: 14.1245,
    transform: "matrix(0.696258 0.717792 -0.696258 0.717792 51.9554 107.535)",
    fill: "#D41D24"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    width: 14.1245,
    height: 14.1245,
    transform: "matrix(0.696258 0.717792 -0.696258 0.717792 51.9554 172.055)",
    fill: "#D41D24"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 14.1245,
    height: 14.1245,
    transform: "matrix(0.696258 0.717792 -0.696258 0.717792 51.9554 238.966)",
    fill: "#D41D24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1000003347);
export default __webpack_public_path__ + "static/media/Group 1000003347.a0c4d66058f7712979d0d28a73ab2569.svg";
export { ForwardRef as ReactComponent };